/** User side of support access (decision D-16). See src/native/supportAccess.ts. */
import httpClient from './auth-http-client'
import {
    type SupportAccessRow,
    type SupportAccessState,
    normalizeSupportAccessRow,
    parseSupportAccessState,
} from '@/native/supportAccess'
import { type SupportSessionInfo, parseSupportSession } from '@/utils/supportView'

/** Null when it could not be read. */
export async function getSupportAccess(): Promise<SupportAccessState | null> {
    const res: any = await httpClient.get('/user/support-access')
    if (res?.status !== 200) return null
    return parseSupportAccessState(res.data)
}

export async function respondSupportAccess(id: string, approve: boolean): Promise<SupportAccessRow | null> {
    const res: any = await httpClient.post(`/user/support-access/${encodeURIComponent(id)}/respond`, { approve })
    if (res?.status !== 200) return null
    return normalizeSupportAccessRow(res.data)
}

export async function revokeSupportAccess(): Promise<boolean> {
    const res: any = await httpClient.post('/user/support-access/revoke', {})
    return res?.status === 200
}

/**
 * Support view: whether the caller's current session is a staff impersonation, and in which mode
 * (`limited` = email hidden, `full` = the customer approved email access). Null when it could not be read.
 */
export async function getSupportSession(): Promise<SupportSessionInfo | null> {
    const res: any = await httpClient.get('/user/support-session')
    if (res?.status !== 200) return null
    return parseSupportSession(res.data)
}
